import tags from "../../components/tags";
import { icons } from "../../components/html";
import { statusCodes } from "../../components/responses";

export default {
  "/measures": {
    get: {
      tags: [tags.sizeIdDatabase],
      summary: "Measures used in SizeID",
      description: `${icons.c}
      Returns all measures that sizeId standard uses including hints how to measure and link on illustration image.`,
      parameters: [{ $ref: "#/components/parameters/acceptsLanguages" }],

      responses: {
        "200": {
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  id: {
                    type: "string",
                    description: "Unique identifier of table",
                    example: "bodyHeight"
                  },
                  label: {
                    type: "string",
                    description: "Description",
                    example: "Výška postavy"
                  },
                  advanced: {
                    type: "boolean",
                    description:
                      "determines whether it is a basic or advanced measure",
                    example: "false"
                  },
                  limits: {
                    $ref: "#/components/schemas/measureLimits"
                  },
                  hints: {
                    $ref: "#/components/schemas/measurementInstruction"
                  },
                  images: {
                    $ref: "#/components/schemas/measureImages"
                  },
                  gender: {
                    $ref: "#/components/schemas/gender"
                  }
                }
              }
            }
          }
        },
        ...statusCodes
      }
    }
  }
};
